import * as React from 'react'
import { useSearchParams } from 'react-router-dom'

import LoginMessage from 'components/common/login-message'

const ProfileDeleted = (): React.ReactNode => {
  const [searchParams] = useSearchParams()
  const sole = searchParams.get('sole')
  const message =
    sole && sole === '1'
      ? 'Thanks – your information is being deleted from DISCO, and your DISCO will also be deleted.'
      : 'Thanks – your information is being deleted from DISCO.'
  return (
    <LoginMessage title="Password changed">
      <p>{message}</p>
    </LoginMessage>
  )
}

export default ProfileDeleted
